import React from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../../../components/Loader';
import useFetchFoundations from '../../../hooks/admin/useFetchFoundations';
import AdTable from '../components/AdTable';

const Index = () => {
  const { company } = useParams();
  console.log('company:', company);

  const { columns, data, loading, error, refetch } = useFetchFoundations({
    company,
  });

  return (
    <div>
      {loading ? (
        <Loader />
      ) : error ? (
        <p>{error.message}</p>
      ) : (
        <AdTable
          data={data}
          columns={columns}
          font='fundación'
          refetch={refetch}
        />
      )}
    </div>
  );
};

export default Index;
